module.exports = __webpack_public_path__ + "static/mstile-150x150-67fb811b2c54534f9cd96f1395356a67.png";